import { create } from "zustand";

export interface topbarStoreInterface {
  anchorLang: (EventTarget & HTMLElement) | null;
  changeAnchorLang: (state: (EventTarget & HTMLElement) | null) => void;
  anchorDate: (EventTarget & HTMLElement) | null;
  changeAnchorDate: (state: (EventTarget & HTMLElement) | null) => void;
  anchorHelp: (EventTarget & HTMLElement) | null;
  changeAnchorHelp: (state: (EventTarget & HTMLElement) | null) => void;
  anchorUser: (EventTarget & HTMLElement) | null;
  changeAnchorUser: (state: (EventTarget & HTMLElement) | null) => void;

  anchorMobile: (EventTarget & HTMLElement) | null;
  changeAnchorMobile: (state: (EventTarget & HTMLElement) | null) => void;
  showHelp: boolean;
  changeShowHelp: (state: boolean) => void;
}

export const topbarStore = create<topbarStoreInterface>()((set) => ({
  anchorLang: null,
  changeAnchorLang: (state: (EventTarget & HTMLElement) | null) =>
    set(() => ({ anchorLang: state })),

  anchorDate: null,
  changeAnchorDate: (state: (EventTarget & HTMLElement) | null) =>
    set(() => ({ anchorDate: state })),

  anchorHelp: null,
  changeAnchorHelp: (state: (EventTarget & HTMLElement) | null) =>
    set(() => ({ anchorHelp: state })),

  anchorUser: null,
  changeAnchorUser: (state: (EventTarget & HTMLElement) | null) =>
    set(() => ({ anchorUser: state })),

  anchorMobile: null,
  changeAnchorMobile: (state: (EventTarget & HTMLElement) | null) =>
    set(() => ({ anchorMobile: state })),

  showHelp: false,
  changeShowHelp: (state: boolean) => set(() => ({ showHelp: state })),
}));
